angular.module('qkr').service('messageService', ['$rootScope', '$log', 'gettextCatalog', '_',
    function messageService($rootScope, $log, gettextCatalog, _) {
        const message = {};

        /**
         * Broadcast a success message
         * @param text - the text to display
         */
        this.success = function(text) {
            $log.info('messageService.success text: ', text);
            message.type = 'success';
            this.show(text);
        };

        /**
         * Broadcast a warning message
         * @param text - the text to display
         */
        this.warning = function(text) {
            $log.warn('messageService.warning text: ', text);
            message.type = 'warning';
            this.show(text);
        };

        /**
         * Broadcast a error message (always shows "An unexpected error has occurred")
         * @param reason - the text to display
         * @param content - the text to display
         */
        this.error = function(reason, content) {
            this.errorWithReason(reason, content, false);
        };

        /**
         * Broadcast a error message, is showReason is true then reason is used
         * as message otherwise generic unexpected error
         * @param reason - the text to display
         * @param content - the text to display
         * @param showReason - the text to display
         */
        this.errorWithReason = function(reason, content, showReason) {
            if (content) {
                $log.error(reason, content);
            } else {
                $log.error('messageService.error text: ', reason);
            }

            // The same code is in form help, for no need of another service.
            const text = this.getTextForError(reason, showReason);

            message.type = 'error';
            this.show(text);
        };

        /**
         * Display a message
         * @param text
         */
        this.show = function(text) {
            $log.info('messageService.show text: ', text);
            message.text = text;
            message.show = true;
            $rootScope.$broadcast('messageBroadcast');
        };

        this.log = function(message, content) {
            if (content) {
                $log.log(message, content);
            } else {
                $log.log(message);
            }
        };

        /**
         * Display a message
         */
        this.hide = function() {
            $rootScope.$broadcast('messageHideBroadcast');
        };

        /**
         * Returns the current message
         * @return {*}
         */
        this.getMessage = function() {
            return message;
        };

        // only for not use the global function saveAlert, here I can Inject the service and also mock it.
        this.saveAlert = (content) => {
            $('.popup-background').show();
            $("#save-alert-message").text(typeof content == 'undefined' ? "Changes Saved" : content);

            $('.save-alert').slideToggle().delay(2000).slideToggle(function() {

                $('.popup-background').hide();

            });
        };

        this.getTextForErrors = function(errors) {
            let text = '';
            angular.forEach(errors, (obj) => {
                text += obj.reason + ' <br>';
            });
            return text;
        };

        this.getTextForError = function(reason, showReason) {
            if (showReason) {
                return reason; // Note. server needs to translate
            }

            if (reason.data) {
                if (_.isArray(reason.data.errors)) {
                    return this.getTextForErrors(reason.data.errors);
                } else if (reason.data.message) {
                    return reason.data.message;
                } else if (reason.data.exception) {
                    return reason.data.exception;
                }
            } else if (reason.errors && _.isArray(reason.errors)) {
                return this.getTextForErrors(reason.errors);
            } else if (reason.message) {
                return reason.message;
            } else if (reason.exception) {
                return reason.exception;
            }

            return gettextCatalog.getString('An unexpected error has occurred');
        };
    }
]);




// WEBPACK FOOTER //
// ./src/services/messageService.js